import { getServiceName } from '@repo/utils';

import BubblechatUseRestrictionPolicy from './bubblechat'; // bubblechat 전용
import TingleUseRestrictionPolicy from './tingle'; // tingle 전용

const UseRestrictionPolicy = () => {
  const serviceName = getServiceName();
  if (serviceName === 'tingle') return <TingleUseRestrictionPolicy />;
  return <BubblechatUseRestrictionPolicy />;
};

export default UseRestrictionPolicy;
